{
  "guide": "guide",
  "unable-to-load-article": "Unable to load {{type}} with ID {{id}}",
  "Resources": "Resources",
  "Related": "Related",
  "Back to collection": "Back to Collection",
  "Are you sure that you want to cancel your enrolment in this course?": "Are you sure you want to cancel your enrollment?",
  "Application for {{product}}": "Application for {{product}}",
  "Upcoming": "Upcoming",
  "provider-application-required": "Applying to this course requires that you first join ",
  "provider-application-pending": "You have a pending approval to access {{provider}}.",
  "request-access": "Request access",
  "provider-access-approved": "Your license to {{provider}} was approved",
  "provider-access-pending": "Your access to {{provider}} was requested",
  "Start": "Start",
  "Open": "Open",
  "View Completed": "View Completed learning",
  "Continue": "Continue",
  "Retake": "Retake",
  "Registration failed": "Registration failed",
  "Cancel enrollment": "Cancel",
  "Follow link": "Proceed",
  "Go to course": "Go to learning",
  "pending approval": "Pending approval",
  "not a member of required groups": "Access required",
  "Learning path": "Learning path",
  "Discussions": "Discussion",
  "Reflections": "Reflection",
  "Participants": "Participants",
  "Description": "Description",
  "Post": "Post",
  "Reflection": "Reflection",
  "The module content cannot be displayed on this page using your current browser.": "The browser you are using does not support the learning content.",
  "Click the link below to open the module in a new tab.": "Click the link below to open the learning item in a new tab",
  "Go to module": "Go to learning item",
  "There is no description": "No description.",
  "There are no participants yet": "No participants yet.",
  "total-participants": "This learning path has one participant.",
  "total-participants_plural": "This learning path has a total of {{count}} participants.",
  "all-enrollments": "All sessions has one participant.",
  "all-enrollments_plural": "All sessions has a total of {{count}} participants.",
  "total-enrollments": "This session has one participant.",
  "total-enrollments_plural": "This session has a total of {{count}} participants.",
  "Apply": "Apply",
  "Enroll": "Join",
  "Enrolled": "Joined",
  "Ongoing": "Ongoing",
  "Cancel waitlist": "Cancel waitlist",
  "Join waitlist": "Join waitlist",
  "No seats available": "No seats available",
  "You will be added if a seat becomes available": "You will be added if a seat becomes available",
  "Enrolled successfully": "Success",
  "Cancelled enrollment successfully": "Cancelled",
  "Add to calendar": "Add to calendar",
  "Web calendars": "Web calendars",
  "iCal file downloaded successfully.": "iCal file downloaded successully. Open the file to add the event to your calendar",
  "Event opened with calendar: {{calendar}}": "Event opened with calendar: {{calendar}}",
  "Go to webinar": "Go to webinar",
  "mark-complete": "mark as completed",
  "completed": "completed",
  "no-registration": "You aren't registered to this learning",
  "Your browser is currently not supported. Please use Chrome or Edge-Chromium.": "Your browser is currently not supported. Please use Chrome or Edge-Chromium.",
  "mandatory-expires": "This course is mandatory and expires in {{count}} days",
  "mandatory-expires-plural": "This course is mandatory and expires in {{count}} days",
  "mandatory-expires-singular": "This course is mandatory and expires in {{count}} day",
  "mandatory-expired": "This course is mandatory and has expired ",
  "retake-modal-header": "Retake course",
  "retake-modal-message": "Your previous progress won't disappear but the course will move to the Ongoing section.",
  "Fill in competency assessment": "Fill in competency assessment"
}
